import { formatLanguage, getLocaleFractionDivider, parseFloatLocale } from '@/helper/Translations'

export function formatToLocaleDivider(value: string) {
  return parseFloatLocale(value).toLocaleString(formatLanguage(), {
    minimumFractionDigits: 1,
    maximumFractionDigits: 2,
    useGrouping: false
  })
}

export function formatNumberToFixed(value: string) {
  const fractionDivider = getLocaleFractionDivider()
  const thousandsDivider = [',', '.'].find(s => s !== fractionDivider)

  if (value.length > 1 && isNaN(parseFloat(value))) {
    return ''
  } else if (value.includes(fractionDivider) && value.length > value.indexOf(fractionDivider) + 2) {
    return formatToLocaleDivider(value).toString()
  } else if (value.includes(thousandsDivider!)) {
    return value.replace(thousandsDivider!, fractionDivider)
  }

  return value
}
